import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import textBrushImg from '@src/img/cursors/text_brush.png';
import shapeBrushImg from '@src/img/cursors/shape_brush.png';
import { CUSTOM } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { IFormatBrushManager } from './interface';
import { IAnimBrushManager } from '../../anim-brush/core/interface';

const isIE = browser.isIE || browser.isEdge;

type CursorType = 'TEXT' | 'SHAPE';
export const cursorImageMap: Record<CursorType, string> = {
    // IE下用CDN地址
    TEXT: isIE ? CUSTOM.IMAGE.BRUSH_IE : textBrushImg,
    SHAPE: isIE ? CUSTOM.IMAGE.BRUSH_IE : shapeBrushImg,
};

/**
 * 获取格式刷的样式
 * 格式为 url({cursor.png}) x y, auto
 * 格式文档参照：https://developer.mozilla.org/zh-CN/docs/Web/CSS/cursor
 * 基本逻辑：文本类型格式刷为"文本格式刷样式"，其余都是"普通(Shape)格式刷样式"
 */
export function getBrushCursorStyle(isTextType: boolean) {
    const textBrushCursorStyle = `url("${cursorImageMap.TEXT}")10 10, auto`;
    const shapeBrushCursorStyle = `url("${cursorImageMap.SHAPE}")3 3, auto`;

    return isTextType ? textBrushCursorStyle : shapeBrushCursorStyle;
}

/**
 * 是否需要使用格式刷的样式指针
 * 格式刷或动画刷激活时需要
 * @param formatBrushManager 格式刷
 * @param animBrushManager 动画刷
 * @returns boolean
 */
export function needBrushCursor(params:
{ formatBrushManager?: IFormatBrushManager, animBrushManager?: IAnimBrushManager}): boolean {
    const { formatBrushManager, animBrushManager } = params;
    const { formatBrushState } = formatBrushManager || {};
    const { animBrushState } = animBrushManager || {};

    return formatBrushState?.data
        || (animBrushState && !animBrushState.allMediaEffect);
}
